import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useState, useEffect } from 'react';
import { Heading, Button, FormLabel, Select, Textarea, Box, useToast, Tooltip } from '@chakra-ui/react';
import ConditionalWrapper from '@interness/web-core/src/components/structure/ConditionalWrapper/ConditionalWrapper';
import { StoreContext } from '../../context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SelectField = _ref => {
  let {
    field,
    onChangeFieldValue
  } = _ref;
  const {
    display_name,
    description,
    options
  } = field;
  useEffect(() => {
    onChangeFieldValue(display_name, options[0]);
  }, []);
  return ___EmotionJSX(Box, {
    my: 5
  }, ___EmotionJSX(FormLabel, {
    htmlFor: display_name
  }, ___EmotionJSX("b", null, display_name)), ___EmotionJSX(Select, {
    variant: "filled",
    id: display_name,
    onChange: e => onChangeFieldValue(display_name, e.target.value),
    required: true
  }, options.map(option => ___EmotionJSX("option", {
    key: option,
    value: option
  }, option))), description && ___EmotionJSX("p", null, description));
};
const TextareaField = _ref2 => {
  let {
    field,
    onChangeFieldValue
  } = _ref2;
  const {
    0: charCount,
    1: setCharCount
  } = useState(0);
  const {
    display_name,
    description,
    max_input_length
  } = field;
  const CharCount = ___EmotionJSX("p", null, "(", `${charCount} / ${max_input_length}`, ")");
  const onChange = value => {
    setCharCount(value.length);
    onChangeFieldValue(display_name, value);
  };
  return ___EmotionJSX(Box, {
    my: 5
  }, ___EmotionJSX(FormLabel, {
    htmlFor: display_name
  }, ___EmotionJSX("b", null, display_name, " ", max_input_length && CharCount)), ___EmotionJSX(Textarea, {
    variant: "filled",
    id: display_name,
    maxLength: max_input_length && max_input_length,
    onBlur: e => onChange(e.target.value),
    onChange: e => onChange(e.target.value),
    required: true
  }), description && ___EmotionJSX("p", null, description));
};
const Personalization = _ref3 => {
  let {
    disabled
  } = _ref3;
  const toast = useToast();
  const {
    currentProduct,
    currentProductDispatcher
  } = useContext(StoreContext);
  const {
    0: isValid,
    1: setIsValid
  } = useState(false);
  const {
    0: state,
    1: setState
  } = useState();
  const personalization = currentProduct.details.personalization;
  const checkValidity = setFields => {
    let valid = false;
    personalization.fields.forEach(field => {
      valid = !!(setFields[field.display_name] && setFields[field.display_name].length >= 1);
    });
    setIsValid(valid);
  };
  const onChangeFieldValue = (field, value) => {
    const localState = _objectSpread({}, state);
    localState[field] = value;
    setState(localState);
    checkValidity(localState);
  };
  const onSavePersonalization = () => {
    currentProductDispatcher({
      type: 'personalizationChange',
      payload: {
        config: personalization,
        values: state
      }
    });
    toast({
      title: 'Personalisierung erfolgreich hinzugefügt',
      status: 'success',
      isClosable: true
    });
  };
  return ___EmotionJSX("div", null, ___EmotionJSX(Heading, {
    as: "h3",
    size: "lg"
  }, personalization.display_name), ___EmotionJSX("div", null, personalization.fields.map((field, i) => {
    switch (field.type) {
      case 'sel':
        return ___EmotionJSX(SelectField, {
          key: field.display_name + i,
          field: field,
          onChangeFieldValue: onChangeFieldValue
        });
      case 'textar':
        return ___EmotionJSX(TextareaField, {
          key: field.display_name + i,
          field: field,
          onChangeFieldValue: onChangeFieldValue
        });
      default:
        return ___EmotionJSX("p", {
          key: field.display_name + i
        }, "Field not found");
    }
  })), ___EmotionJSX(Box, {
    textAlign: "right"
  }, ___EmotionJSX(Button, {
    colorScheme: "brand",
    isDisabled: disabled || !isValid,
    onClick: onSavePersonalization
  }, "Speichern"), currentProduct.hasVariants && !currentProduct.variantSelected && ___EmotionJSX("p", null, "Bitte Variante w\xE4hlen")));
};
export default Personalization;